import React from "react";
import { useLocation, useNavigate } from "react-router";
import { Badge, Tooltip, ListItem, useTheme } from "@mui/material";

const SideNavTab = ({
  icon,
  title,
  route,
  onClick,
  disabled,
  showTab = true,
  badgeCount = 0,
  baseRoute = null,
  showBadge = false,
}) => {
  const theme = useTheme();

  const location = useLocation();
  const navigate = useNavigate();

  const selected =
    location.pathname.includes(route) || location.pathname.includes(baseRoute);

  if (!showTab) return <></>;

  return (
    <Tooltip title={title} placement="right">
      <ListItem
        key={title}
        button
        onClick={() => {
          onClick && onClick();
          navigate(route);
        }}
        selected={selected}
        style={{
          margin: "6px 0",
          color: theme.palette.primary.light,
          backgroundColor: selected
            ? theme.palette.type === "dark"
              ? "rgba(148, 186, 51, 0.2)"
              : "#f1f6e3"
            : null,
        }}
        disabled={disabled}
      >
        {showBadge && badgeCount > 0 ? (
          <Badge
            color="secondary"
            badgeContent={badgeCount}
            variant="dot"
            overlap="circular"
            max={9999}
          >
            <div style={{ color: "#444444" }}>{icon}</div>
          </Badge>
        ) : (
          <div style={{ color: "#444444" }}>{icon}</div>
        )}
      </ListItem>
    </Tooltip>
  );
};

export default SideNavTab;
